import React from 'react';
import { LocationPrivacyRedirect } from './LocationPrivacyRedirect';

export const LocationPrivacyCheck: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <LocationPrivacyRedirect />;
};
